import { WHALE_FOLLOW_HIDDEN as localStorageKey } from '../KEYS';

// "Don't show again" on the whale-alerts modal. Per browser, not per
// account: the whale panel is public, so a logged-out visitor has no account
// to key on, and the demo-stand reset clears it with the other per-visitor
// rows.
export default {
  get(): boolean {
    return localStorage.getItem(localStorageKey) === JSON.stringify(true);
  },

  set() {
    localStorage.setItem(localStorageKey, JSON.stringify(true));
  },

  clear() {
    localStorage.removeItem(localStorageKey);
  },
};
